import manager from 'app/module46/component-manager.js';

manager.register('event-form', pricingForm);

/**
 * @param {HTMLFormElement} component
 * @param {Object.<string, Element>} references
 * @param {Array.<Element>} references.errors
 * @param {Object.<string, string>} attributes
 * @param {Object.<string, string>} properties
 */
function pricingForm(component, references, attributes, properties) {
	const {
		tableOptionCheckbox,
		tableOption,
		videoOptionCheckbox,
		videoOption,
		photoOptionCheckbox,
		photoOption
	} = references;

	const showInputSection = (input) => {
		input.closest('.form__field').style.removeProperty('display');
	};

	const hideInputSection = (input) => {
		input.closest('.form__field').style.display = 'none';
	};

	const handleOptionChange = (checkbox, options) => {
		if (checkbox.checked) {
			if (Array.isArray(options)) {
				for (const optionElement of options) {
					showInputSection(optionElement);
				}
			} else {
				showInputSection(options);
			}
		} else {
			if (Array.isArray(options)) {
				for (const optionElement of options) {
					hideInputSection(optionElement);
				}
			} else {
				hideInputSection(options);
			}
		}
	};

	tableOptionCheckbox.addEventListener('change', () => {
		handleOptionChange(tableOptionCheckbox, tableOption);
	});
	videoOptionCheckbox.addEventListener('change', () => {
		handleOptionChange(videoOptionCheckbox, videoOption);
	});
	photoOptionCheckbox.addEventListener('change', () => {
		handleOptionChange(photoOptionCheckbox, photoOption);
	});

	handleOptionChange(tableOptionCheckbox, tableOption);
	handleOptionChange(videoOptionCheckbox, videoOption);
	handleOptionChange(photoOptionCheckbox, photoOption);
}
